import {
  FETCH_TUTORIAL_LIST,
  FETCH_TUTORIAL_STEPS,
  UPDATE_STEP,
  UPDATE_STEP_NB,
  UPDATE_FRAME,
  ANIMATE_STEP,
  ANIMATE_ALL,
  ANIMATE_ALL_TERM
} from './constants'
import { CLEAR_CONTENT } from '../App/constants'

const initialState = {
  isFetching: true,
  isFetchingSteps: true,
  mostSeenTutorials: [],
  tutorials: [],
  currentTutorial: [],
  currentPhoneId: null,
  currentTutorialId: null,
  currentStep: 0,
  currentFrame: -1,
  isPlayingStep: false,
  isPlayingAll: false
}

// 15NOV2017 - Sort flash tutorials to the bottom of each category for a better browsing experience
const bottomSortFlashTutorials = tutorials => {
  return tutorials.map(function(category) {
    return {
      ...category,
      children: [
        ...category.children.filter(function(tutorial) {
          return tutorial.tutorialtype.toUpperCase() !== 'FLASH'
        }),
        ...category.children.filter(function(tutorial) {
          return tutorial.tutorialtype.toUpperCase() === 'FLASH'
        })
      ]
    }
  })
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_TUTORIAL_LIST['REQUEST']: {
      return {
        ...state,
        isFetching: true,
        tutorials: []
      }
    }
    case FETCH_TUTORIAL_LIST['SUCCESS']: {
      return {
        ...state,
        currentPhoneId: action.currentPhoneId,
        tutorials: bottomSortFlashTutorials(action.tutorials),
        isFetching: false
      }
    }
    case FETCH_TUTORIAL_STEPS['REQUEST']: {
      return {
        ...state,
        isFetchingSteps: true,
        currentTutorial: []
        //currentTutorialId: null
      }
    }
    case FETCH_TUTORIAL_STEPS['SUCCESS']: {
      return {
        ...state,
        isFetchingSteps: false,
        currentTutorial: action.tutorial,
        currentTutorialId: action.tutorialId,
        currentStep: 0,
        currentFrame: -1,
        isPlayingStep: false,
        isPlayingAll: false
      }
    }
    case UPDATE_STEP: {
      return {
        ...state,
        currentFrame: -1,
        currentStep: action.step,
        isPlayingStep: false,
        isPlayingAll: false
      }
    }
    case UPDATE_STEP_NB: {
      return {
        ...state,
        currentFrame: -1,
        currentStep: action.step,
        isPlayingStep: false
      }
    }
    case UPDATE_FRAME: {
      return {
        ...state,
        currentFrame: action.index
      }
    }
    case ANIMATE_STEP: {
      return {
        ...state,
        isPlayingStep: true
      }
    }
    case ANIMATE_ALL: {
      return {
        ...state,
        isPlayingAll: true
      }
    }
    case ANIMATE_ALL_TERM: {
      return {
        ...state,
        isPlayingAll: false
      }
    }
    case CLEAR_CONTENT: {
      return {
        ...state,
        tutorials: []
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/Tutorials/reducer.js